import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/Auth/auth-context";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { toast } from "react-toastify";
import { track } from "../../services/analytics";

export function SignIn() {
  const { loginViaGoogle, token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [signingIn, setSigningIn] = useState(false);
  // Where ProtectedRoute sent us from (path + query, e.g. "/?pin=123456") —
  // return there after auth so a scanned join QR keeps its PIN.
  const from = (location.state as { from?: string } | null)?.from;

  const loginWithGoogleHandler = async () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    setSigningIn(true);
    try {
      await signInWithPopup(auth, provider);
      loginViaGoogle(auth);
      track("login", { method: "google" });
    } catch (error) {
      toast.error("Google sign-in error");
      console.error("Google sign-in error:", error);
    } finally {
      setSigningIn(false);
    }
  };

  useEffect(() => {
    if (!token) return;
    const id = setTimeout(() => navigate(from || "/"), 1000);
    return () => clearTimeout(id);
  }, [token, navigate, from]);

  return (
    <div className="stage flex items-center justify-center px-4 py-12">
      <div className="card w-full max-w-md p-8 text-center animate-pop">
        <span className="mx-auto mb-4 grid grid-cols-2 w-14 h-14 rounded-xl overflow-hidden border-2 border-ink shrink-0">
          <span className="bg-tile-red" /><span className="bg-tile-blue" />
          <span className="bg-tile-gold" /><span className="bg-tile-green" />
        </span>
        <h1 className="text-3xl font-extrabold font-display tracking-tight">
          Quiz<span className="text-tile-red">Live</span>
        </h1>
        <p className="text-xs font-medium text-slate-400 mt-1">by aliensbrain</p>
        <p className="text-slate-500 mt-3 mb-8">
          Play live quizzes with the stream and climb the leaderboard.
        </p>
        <button
          onClick={loginWithGoogleHandler}
          disabled={signingIn}
          className="btn-primary w-full text-lg flex items-center justify-center gap-3"
        >
          <span className="grid place-items-center w-6 h-6 rounded-full bg-white text-ink border border-ink/20 text-sm font-black">
            G
          </span>
          {signingIn ? "Signing in…" : "Continue with Google"}
        </button>
        <p className="text-xs text-slate-400 mt-4">
          One tap — your Google name becomes your player name (you can change it
          when you join a game).
        </p>
      </div>
    </div>
  );
}
